import { create } from "zustand";

const useVisitedPathStore = create((set, get) => ({
    lastVisitedPath: null,

    // Set last visited path before redirecting to login
    setLastVisitedPath: (path) => set({ lastVisitedPath: path }),

    // Get and reset last visited path after login
    consumeLastVisitedPath: () => {
        const path = get().lastVisitedPath; // Get the current value
        set({ lastVisitedPath: null }); // Reset it
        return path || "/"; // Return the stored path or default to "/"
    },

    resetLastVisitedPath: () => set({ lastVisitedPath: null })
}));

export default useVisitedPathStore;
